var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('rect',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"12","fill":"#2B9F5A"}}),_c('circle',{attrs:{"xmlns":"http://www.w3.org/2000/svg","cx":"7","cy":"6","r":"4","fill":"#E31D1C"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }